import * as RTooltip from "@radix-ui/react-tooltip";

interface TooltipProviderProps {
    children: React.ReactNode;
}
export function TooltipProvider({ children }: TooltipProviderProps) {
    return <RTooltip.Provider>{children}</RTooltip.Provider>;
}
